import {
  MultimediaPurchaseHistoryListResponse,
  MultimediaPurchaseHistoryResponse,
} from "@API/src/component/memoruHome/purchaseHistory/types";

export const isTypeMultimediaPurchaseHistoryListResponse = (
  arg
): arg is MultimediaPurchaseHistoryListResponse =>
  arg !== null &&
  typeof arg === "object" &&
  typeof (arg as MultimediaPurchaseHistoryListResponse).items === "object" &&
  typeof (arg as MultimediaPurchaseHistoryListResponse).total === "number";

export const isTypeMultimediaPurchaseHistoryResponse = (
  arg
): arg is MultimediaPurchaseHistoryResponse =>
  arg !== null &&
  typeof arg === "object" &&
  typeof (arg as MultimediaPurchaseHistoryResponse).cartId === "number" &&
  typeof (arg as MultimediaPurchaseHistoryResponse).status === "string";
